<template>
  <v-card class="d-flex pa-4 flex-column" outlined>
    <v-alert
      v-model="flashError"
      dense
      border="left"
      type="error"
      dismissible
      elevation="2"
    >
      {{ flashErrorMessage }}
    </v-alert>
    <InformationAlert />

    <TableSearchFilter
      :search="{ rrn: '', nmid: '', mid: '' }"
      @search="updateSearch" 
      @showType="showType"
      :filters="[
        { key: 'rrn', type: 'textfield', props: { label: 'RRN *' } },
        { key: 'nmid', type: 'textfield', props: { label: 'NMID' } },
        { key: 'mid', type: 'textfield', props: { label: 'MID' } },
      ]"
    />

    <TableView
      :headers="headers"
      :items="allData"
      :options.sync="options"
      :loading="loading"
      :selected-items="selectedData"
      :totalData="totalData"
      :refresh-table="refeshTable"
      :customTopActions="true"
      item-key="id"
      table-height="70vh"
      @select-row="selectRow"
      @view-detail="viewDetail"
      @clear-selected="clearSelected"
    >
    <template v-slot:top>
        <v-toolbar flat>
          <v-chip
            v-if="selectedData.length > 0"
            close
            @click:close="clearSelected"
          >
            {{ `${selectedData.length} data(s) selected` }}
          </v-chip>

          <v-spacer />
          <template>
            <v-btn
              color="error"
              class="mb-2 rounded-pill"
              @click="openRejectDialog(true)"
              :style="{ 'margin-right': '10px' }"
              :disabled="loading"
              >Reject
            </v-btn>
            <v-btn

              color="primary"
              class="mb-2 rounded-pill"
              @click="openApproveDialog(true)"
              :style="{ 'margin-right': '10px' }"
              :disabled="loading"
              >Approve
            </v-btn>
            <v-btn
              color="warning"
              icon
              class="mb-2"
              @click="refeshTable"
              :loading="loading"
              :disabled="loading"
              :style="{ 'margin-right': '10px' }"
              ><v-icon>mdi-refresh</v-icon></v-btn
            >
            <v-menu
              offset-y
              rounded="lg"
              transition="slide-y-transition"
              bottom
              left
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="warning"
                  class="mb-2"
                  icon
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon light size="20">mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
            </v-menu>
          </template>
        </v-toolbar>
      </template>
      <template v-slot:custom="{ item }">
        <v-checkbox
              class="ma-0"
              dense
              hide-details="true"
              v-model="selectedData"
              :value="item.id"
            />
      </template>
      <template slot="action" slot-scope="{ item }">
      <div class="d-flex justify-center align-center" style="height: 100%">
        <v-icon
          @click="viewDetail(item.id)"
          size="20"
        >
          mdi-eye
        </v-icon>
      </div>
    </template>
    </TableView>

    <v-dialog v-model="showProgressBar" persistent max-width="500">
      <div style="width: 100%; height: 10px; background-color: #146b76"></div> 
      <v-card class="d-flex flex-column align-center pa-4">
        <v-card-title class="text-h6 text-center">{{ progressTitle }}</v-card-title>

        <v-card-text class="d-flex flex-column align-center pa-4">
          <v-progress-linear :value="percentage" :color="progressColor" height="15" class="mb-3 rounded-xl " style="width: 100%"/>
          <div class="text-center">
            <strong>{{ Math.ceil(percentage) }}%</strong>
          </div>

          <v-row class="justify-center mt-10" style="width: 100%">
            <v-col cols="6" class="d-flex justify-center">
              <v-btn min-width="100%" @click="closeProgressBar" :disabled="disabledProgress">OK</v-btn>
            </v-col>
            <v-col cols="6" class="d-flex justify-center">
              <v-btn min-width="100%" color="primary" @click="goToHistory" :disabled="disabledProgress">Go to History Request</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogConfirm" width="700" persistent>
      <confirm-dialog
        :title="dialogTitle"
        :caution="dialogCaution"
        :mode="dialogMode"
        :remark="remark"
        v-on:closeCancelParent="close"
        v-on:confirmParent="actionInsert"
        @update:remark="updateRemark"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import { headers, search, editedItem} from '../../components/insert-transaction-on-us/approval-insert-transaction/attributes';
import { getDate, date, showAlert } from '../../lib/helpers';

export default {
  components: {
    ConfirmDialog: () => import('../../components/insert-transaction-on-us/approval-insert-transaction/ConfirmDialog.vue'),
    InformationAlert: () => import('../../components/insert-transaction-on-us/InformationAlert.vue'),
    TableView: () => import("../../components/@drontVue/components/Table/TableView.vue"),
    TableSearchFilter: () => import("../../components/@drontVue/components/SearchFilter/TableSearchFilter.vue"),
  },
  data: () => ({
    options: {},
    show: false,
    dialog: false,
    dialogConfirm: false,
    headers,
    search,
    remark: '',
    editedItem,
    defaultItem: {},
    selectedRow: null,
    editedIndex: -1,
    selectedData: [],
    selectAllData: false,
    selectedStat: false,
    dialogMode: 'approve',
    isResetData: true,
  }),

  computed: {
    disabledProgress() {
      if (this.percentage < 100 && this.failedResponse === false) {
        return true;
      }

      return false;
    },
    allData() {
      return this.$store.state.approvalInsertTransactionOnUs.allData;
    },
    totalData() {
      return this.$store.state.approvalInsertTransactionOnUs.totalData;
    },
    totalPage() {
      return this.$store.state.approvalInsertTransactionOnUs.totalPage;
    },
    loading() {
      return this.$store.state.approvalInsertTransactionOnUs.loading;
    },
    flashError: {
      get() {
        return this.$store.state.approvalInsertTransactionOnUs.flashError;
      },
      set() {
        this.$store.commit('approvalInsertTransactionOnUs/setFlashErrorMessage', '');
      },
    },
    flashErrorMessage() {
      return this.$store.state.approvalInsertTransactionOnUs.flashErrorMessage;
    },
    percentage() {
      return this.$store.state.approvalInsertTransactionOnUs.percentage;
    },
    dialogTitle() {
      if (this.dialogMode === 'reject') {
        return this.selectedData.length > 1 
          ? 'Multiple Reject Request Insert Transaction on Us' 
          : 'Reject Request Insert Transaction on Us';
      }

      return this.selectedData.length > 1 
        ? 'Multiple Approved Request Insert Transaction on Us' 
        : 'Approved Request Insert Transaction on Us';
    },
    dialogCaution() {
      if (this.dialogMode === 'reject') {
        return this.selectedData.length > 1 
          ? 'Apakah Anda yakin akan mengizinkan multiple reject Insert transaction On Us?' 
          : 'Apakah Anda yakin akan mengizinkan reject Insert transaction On Us?';
      }

      return this.selectedData.length > 1 
        ? 'Apakah Anda yakin akan mengizinkan multiple approval Insert transaction On Us?' 
        : 'Apakah Anda yakin akan mengizinkan approval Insert transaction On Us?';
    },
    showProgressBar() {
      return this.$store.state.approvalInsertTransactionOnUs.showProgressBar;
    },
    progressTitle() {
      return this.$store.state.approvalInsertTransactionOnUs.progressTitle;
    },
    progressColor() {
      return this.$store.state.approvalInsertTransactionOnUs.progressColor;
    },
    failedResponse() {
      return this.$store.state.approvalInsertTransactionOnUs.isFailedResponse;
    },
  },

  watch: {
    options: {
      handler() {
        this.getData();
      },
    },

    selectedData: {
      handler() {
        this.checkAllSelected();
      },
    },
  },


  methods: {
    selectRow(index) {
      if (this.selectedRow !== index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },

    viewDetail(id) {
      this.$router.push(`/insert-transaction-on-us/approval-insert-transaction/detail/${id}`);
    },

    rowClass() {
      const rowClass = 'max-width-col';

      return rowClass;
    },

    updateSearch(newSearch) {
      this.search.rrn = newSearch.rrn || ''; 
      this.search.nmid = newSearch.nmid || ''; 
      this.search.mid = newSearch.mid || '';
      this.options.page = 1;
      this.getData(); 
    },
    showType(newSearch) {
      if ((!newSearch || !newSearch.rrn)) {
        this.$vuetify.goTo(0);
        showAlert(this.$store, 'RRN required !', 'mdi-alert', 'red');
      } else {
        this.clearSelected();
        this.search.rrn = newSearch.rrn; 
        this.search.nmid = newSearch.nmid || '';
        this.search.mid = newSearch.mid || '';
        this.options.page = 1;
        this.getData(); 
      }
    },


    getData() {
    
      this.$store.commit('approvalInsertTransactionOnUs/setFlashErrorMessage', '');
      const { page, itemsPerPage} = this.options;

      this.$store
        .dispatch('approvalInsertTransactionOnUs/getData', {
          date,
          page,
          itemsPerPage,
          search: this.search,
        })
        .then(() => {
          if (this.totalPage < page) {
            this.options.page = this.totalPage === 0 ? 1 : this.totalPage;
          }
        })
        .finally(() => {
          this.checkAllSelected();
        });
      
    },

    refeshTable() {
      this.getData();
    },

    close() {
      this.dialog = false;
      this.dialogConfirm = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },

    closeFlash() {
      this.$store.commit('approvalInsertTransactionOnUs/setFlashErrorMessage', '');
    },

    clearSearch() {
      this.search.nmid = '';
      this.search.mid = '';
      this.search.mid_bank = '';
      this.search.rrn = '';
      this.search.payment_channel = '';
      this.search.mpan = '';
      this.search.trx_date = '';
      this.search.trx_time = '';
    },

    formatDate(dateVal) {
      if (!dateVal) return null;

      const [year, month, day] = dateVal.split('-');

      return `${day}/${month}/${year}`;
    },
    parseDate(dateVal) {
      if (!dateVal) return null;

      const [day, month, year] = dateVal.split('/');

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },

    clearSelected() {
      this.selectedData = [];
      this.selectAllData = false;
    },

    openApproveDialog(selected) {
      this.dialogMode = 'approve'; 
      this.selectedStat = selected;

      if (this.selectedStat && this.selectedData.length < 1) {
        showAlert(this.$store, 'Data must be selected!', 'mdi-alert', 'red');
      } else if (!this.selectedStat && this.allData.length < 1) {
        showAlert(this.$store, 'Data not found !', 'mdi-alert', 'red');
      } else {
        this.dialogConfirm = true;
      }
    },
    openRejectDialog(selected) {
      this.dialogMode = 'reject'; 
      this.selectedStat = selected;

      if (this.selectedStat && this.selectedData.length < 1) {
        showAlert(this.$store, 'Data must be selected!', 'mdi-alert', 'red');
      } else if (!this.selectedStat && this.allData.length < 1) {
        showAlert(this.$store, 'Data not found !', 'mdi-alert', 'red');
      } else {
        this.dialogConfirm = true;
      }
    },

    async rejectInsert() {
      this.dialogConfirm = false;
      let idData = this.selectedStat ? this.selectedData : null;
      
      if (idData && Array.isArray(idData)) {
        idData = idData.map(id => parseInt(id, 10)); 
      }

      try {
        const res = await this.$store.dispatch('approvalInsertTransactionOnUs/rejectInsert', {
          date,
          id: idData,
          remark: this.remark,
        });

        if (res !== false) {
          this.clearSelected();
          this.getData();
        } 
      } catch (error) {
        showAlert(this.$store, 'Something Went Wrong !', 'mdi-alert', 'red');
      }
    },

    async approveInsert() {
      this.dialogConfirm = false;
      let idData = this.selectedStat ? this.selectedData : null;

      if (idData && Array.isArray(idData)) {
        idData = idData.map(id => parseInt(id, 10)); 
      }
      try {
        const res = await this.$store.dispatch('approvalInsertTransactionOnUs/approveInsert', {
          date,
          id: idData,
          remark: this.remark,
        });

        if (res !== false) {
          this.clearSelected();
          this.getData();
        } 
      } catch (error) {
        showAlert(this.$store, 'Something Went Wrong !', 'mdi-alert', 'red');
      }
    },

    actionInsert() {
      if (this.dialogMode === 'approve') {
        this.approveInsert();
      } else {
        this.rejectInsert();
      }
    },

    selectAll(status) {
      this.$nextTick(() => {
        const allIds = this.allData.map((val) => val.id);
        const filtered = allIds.filter(
          (val) => !this.selectedData.includes(val)
        );

        if (status) {
          this.selectedData = this.selectedData.concat(filtered);
        } else {
          this.selectedData = this.selectedData.filter(
            (val) => !allIds.includes(val)
          );
        }
      });
    },

    checkAllSelected() {
      const allIds = this.allData.map((val) => val.id);
      const allSelected = allIds.filter(
        (val) => !this.selectedData.includes(val)
      );

      if (
        allSelected.length === 0 &&
        this.selectedData.length > 0 &&
        this.allData.length > 0
      ) {
        this.selectAllData = true;
      } else {
        this.selectAllData = false;
      }
    },
    getDate,

    goToHistory() {
      this.$router.push('/insert-transaction-on-us/history-insert-transaction');
    },
    closeProgressBar() {
      this.$store.dispatch('approvalInsertTransactionOnUs/closeProgressBar');
    },

    updateRemark(newRemark) {
      this.remark = newRemark;
    },
  },
  mounted() {
    this.closeProgressBar();
  },
  beforeRouteLeave(to, from, next) {
    this.clearSearch();
    this.closeProgressBar();
    next();
  },
};
</script>

<style>
.max-width-col td {
  white-space: nowrap;
  overflow: hidden;
  max-width: 250px;
  text-overflow: ellipsis;
}
.v-data-table .v-data-table__wrapper {
  height: 100%;
}
</style>

<style scoped>
.v-application p {
    margin-bottom: 8px;
}

</style>

